import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { reducer as formReducer } from "redux-form";
import { createLogger } from "redux-logger";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import {
  assignPageInitialState,
  assignPageReducer,
  AssignPageState
} from "../pages/assign/assign-page.store";
import { rootSaga } from "../sagas/index.saga";
import { Assign, Employee, Group, Job } from "../types/types";
import { appInitialState, appReducer, AppState } from "./app.store";
import { assignsReducer } from "./assigns.store";
import { employeesReducer } from "./employees.store";
import { groupsReducer } from "./groups.store";
import { jobReducer } from "./jobs.store";
import { masterAssignsReducer } from "./master-assigns.store";
import { uiInitialState, uiReducer, UiState } from "./ui.store";

// https://github.com/reduxjs/redux/issues/738
const reducers = combineReducers({
  domain: combineReducers({
    groups: groupsReducer,
    employees: employeesReducer,
    jobs: jobReducer,
    assigns: assignsReducer,
    masterAssigns: masterAssignsReducer
  }),
  app: appReducer,
  page: combineReducers({
    assign: assignPageReducer
  }),
  ui: uiReducer,
  form: formReducer
});

// noinspection JSUnusedGlobalSymbols
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["domain"]
};

const persistedReducer = persistReducer(persistConfig, reducers);

export interface RootState {
  domain: {
    groups: Group[];
    employees: Employee[];
    jobs: Job[];
    assigns: Assign[];
    masterAssigns: Assign[];
  };
  app: AppState;
  page: {
    assign: AssignPageState;
  };
  ui: UiState;
  _persist?: {
    version: number;
    rehydrated: boolean;
  };
}

const initialState: RootState = {
  domain: {
    groups: [],
    employees: [],
    jobs: [],
    assigns: [],
    masterAssigns: []
  },
  app: appInitialState,
  page: {
    assign: assignPageInitialState
  },
  ui: uiInitialState
};

const logger = createLogger({
  diff: true,
  collapsed: true
});

const sagaMiddleware = createSagaMiddleware();
const middlewares = composeWithDevTools(
  applyMiddleware(logger, sagaMiddleware)
);

export const store = createStore(persistedReducer, initialState, middlewares);
export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);
